module.exports = {
  emptyMessage: '¡Ey!, olvidaste introducir el número de tu tarjeta.',
  defaultMessage: 'El número es invalido. Confirma si no hay un error de escritura y vuelva a intentarlo.',
};
